import { columns } from "../../../../dtos/columns";
import { RespuestaAsientosDescuadrados } from "../models/respuestaAsientosDescuadrados";

export function useColumnsAsientosDescuadrados() {
  const COLUMNS: columns<RespuestaAsientosDescuadrados>[] = [
    {
      name: "Id",
      selector: (row: RespuestaAsientosDescuadrados) => row.idAsiento || '',
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
    {
      name: "Id mutuo",
      selector: (row: RespuestaAsientosDescuadrados) => row.idMutuo || '',
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
    {
      name: "Codigo accion",
      selector: (row: RespuestaAsientosDescuadrados) => row.codigoAccion || '',
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
    {
      name: "N° Dividendo",
      selector: (row: RespuestaAsientosDescuadrados) => row.NDividendo || '',
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
    {
      name: "Debitos",
      selector: (row: RespuestaAsientosDescuadrados) => row.debitos || '',
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
    {
      name: "Creditos",
      selector: (row: RespuestaAsientosDescuadrados) => row.creditos || '',
      sortable: false,
      wrap: true,
      export: true,
      alling: 'center'
    },
  ]

  return { COLUMNS };
}